import ViewTenantComponent from 'components/ViewTenantComponent/ViewTenantComponent'
import React from 'react'

const ViewTenant = () => {
  return (
    <div><ViewTenantComponent /></div>
  )
}

export default ViewTenant